/**
 * Re-export of the shared TrustBadges component for the storefront renderer.
 * The base component (render + fields + defaults) lives in
 * `@launchstore/shared-puck`. The renderer uses it as-is.
 *
 * See launchstore-shared/src/puck/components/homepage/TrustBadges/ for source.
 */
import { TrustBadges as SharedTrustBadges } from '@launchstore/shared-puck';

export const TrustBadges: any = SharedTrustBadges;
export type { TrustBadgesProps, TrustBadgeItem } from '@launchstore/shared-puck';
export default TrustBadges;
